var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pagination" }, [
    _vm.pageCount > 1
      ? _c(
          "ul",
          { staticClass: "pagination-list" },
          [
            _c("li", { class: { "is-disable": _vm.activePage == 1 } }, [
              _c("button", {
                staticClass: "pagination-list__prev",
                on: { click: _vm.decrementPage },
              }),
            ]),
            _vm._l(_vm.pageCount, function (index) {
              return _c(
                "li",
                { key: index, class: { "is-active": _vm.activePage == index } },
                [
                  _c(
                    "button",
                    {
                      staticClass: "pagination-list__button",
                      attrs: { "data-page-number": index },
                      on: { click: _vm.changePage },
                    },
                    [_vm._v(_vm._s(index))]
                  ),
                ]
              )
            }),
            _c(
              "li",
              { class: { "is-disable": _vm.activePage == _vm.pageCount } },
              [
                _c("button", {
                  staticClass: "pagination-list__next",
                  on: { click: _vm.incrementPage },
                }),
              ]
            ),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }